export const RULE_TYPES = {
  PLAN_ENABLE: 2,
  PLAN_DISABLE: 1,
  PLAN_BUDGET: 3,
  PLAN_PRICE: 4,
  PLAN_DELETE: 8,
  PLAN_COPY: 9,
  PLAN_MESSAGE: 5,
  MATERIAL_DISABLE: 11,
  MATERIAL_ENABLE: 12
}

export const RANGE_TYPES = {
  ACCOUNT_LEVEL: 1,
  APP_LEVEL: 2
}

// 在此处生成ruleType的枚举类型
export const ruleTypeEnum = [
  {
    label: '暂停计划',
    value: 1
  },
  {
    label: '启用计划',
    value: 2
  },
  {
    label: '更改预算',
    value: 3
  },
  {
    label: '更改出价',
    value: 4
  },
  {
    label: '删除计划',
    value: 8
  },
  {
    label: '复制计划',
    value: 9
  },
  {
    label: '仅消息提醒',
    value: 5
  },
  {
    label: '暂停素材',
    value: 11
  },
  {
    label: '启用素材',
    value: 12
  }
]
